import { moduleBinary } from "../../common/authority";

const Dropdown = ({ submenus, dropdown }) => {

  return (
    <ul className={`dropdown ${dropdown ? "show" : ""}`}>
      {submenus.map((submenu, index) => (
        // index === 0  
        // ? <li key={index} className="menu-items">
        //     <a href={submenu.key}>{submenu.title}</a>
        //   </li>
        // : <></>
        <li key={index} className="menu-items">
          <a href={submenu.key}>{submenu.title}</a>
        </li>
      ))}
    </ul>
  );
};

export default Dropdown;
